import { useEffect, useState } from 'react'
import { MenuItem } from 'ui/molecules/Menu/MenuItem'
import {
  MENU_ITEM_STATUS_MAP,
  MENU_PATHS,
  OPERATOR_MENU_ITEMS,
  OPERATOR_SUBMENU_ITEMS,
  SUPPLIER_MENU_ITEMS,
} from './constants'
import { useAppSelector } from 'redux/hooks'
import {
  isMigratedUserSelector,
  menuSectionsNotCompletedSelector,
  userDataSelector,
  userRoleSelector,
} from 'redux/login/selectors'
import { UserRoles } from 'constants/roles'
import { useLocation } from 'react-router-dom'
import { useDisableMenuItems } from 'hooks/useDisableMenuItems'
import { OnboardingBlock } from './components/OnboardingBlock'
import { REGISTRATION_STATUSES } from 'api/auth/constants'
import { MigrationSectionsStatuses, RegistrationStatuses } from 'api/auth/types'
import styles from './styles.module.scss'

export const Menu = () => {
  const [activeMenu, setActiveMenu] = useState('')
  const role = useAppSelector(userRoleSelector)
  const location = useLocation()
  const { disableMenuItem } = useDisableMenuItems()
  const isMigratedUser = useAppSelector(isMigratedUserSelector)
  const { sectionsStatuses, migrationSectionsStatuses } =
    useAppSelector(userDataSelector)
  const menuSectionsNotCompleted = useAppSelector(
    menuSectionsNotCompletedSelector
  )

  const isOperator = role === UserRoles.Operator

  const MENU_CONFIG = isOperator
    ? {
        MENU_ITEMS: OPERATOR_MENU_ITEMS,
        SUBMENU_ITEMS: OPERATOR_SUBMENU_ITEMS,
      }
    : {
        MENU_ITEMS: SUPPLIER_MENU_ITEMS,
      }
  useEffect(() => {
    const activeMenu = Object.entries(MENU_PATHS).find(([, value]) =>
      location.pathname.includes(value)
    )?.[0]

    setActiveMenu(activeMenu || '')
  }, [location.pathname])

  const isSectionRequested = (menuName: string) =>
    sectionsStatuses?.[
      MENU_ITEM_STATUS_MAP[menuName] as keyof RegistrationStatuses
    ] === REGISTRATION_STATUSES.REQUESTED

  const isSectionIncomplete = (menuName: string) => {
    if (isMigratedUser) {
      return (
        migrationSectionsStatuses?.[
          MENU_ITEM_STATUS_MAP[menuName] as keyof MigrationSectionsStatuses
        ] === REGISTRATION_STATUSES.INCOMPLETE
      )
    } else {
      return (
        sectionsStatuses?.[
          MENU_ITEM_STATUS_MAP[menuName] as keyof RegistrationStatuses
        ] === REGISTRATION_STATUSES.INCOMPLETE
      )
    }
  }
  return (
    <nav className={styles.menu} data-testid="menu">
      {MENU_CONFIG.MENU_ITEMS.map((menuItem) => (
        <MenuItem
          name={menuItem.name}
          path={menuItem.path}
          key={menuItem.name}
          activeItem={activeMenu}
          incomplete={isSectionIncomplete(menuItem.name)}
          requested={isSectionRequested(menuItem.name)}
          disabled={disableMenuItem(menuItem.name)}
          iconSrc={menuItem.icon}
          onMenuItemClick={setActiveMenu}
          withSubmenu={menuItem.withSubmenu}
        />
      ))}
      {!isOperator && !!menuSectionsNotCompleted?.length && (
        <OnboardingBlock
          uncompletedSectionsCount={menuSectionsNotCompleted.length}
        />
      )}
    </nav>
  )
}
